// Names for things the console shows, read from data rather than code.
//
// A pack's name comes from the pack itself (packages/verticals, served by
// GET /v1/platform/vertical-packs) in every locale the pack carries, so a new
// pack needs no dictionary entry here (doctrine rule 5). When the packs have
// not loaded, or a tenant names a pack this deployment no longer ships, the
// key is shown as written: it is a readable slug, never an invented name.

import { normalizeLocale } from "@assessly/contracts/locales";
import type { VerticalPack } from "./platform-api";

/** The best text for `language` from a per-locale record: exact, then the
 * registry's locale for the tag, then English, then undefined. */
export function pickLocalized(
  record: Readonly<Record<string, string>> | undefined,
  language: string,
): string | undefined {
  if (record === undefined) return undefined;
  // Exact tag first, then the registry's reading of it (`zh-TW` is
  // `zh-Hant`, never `zh`), then English.
  const registry = normalizeLocale(language);
  for (const key of [language, ...(registry === undefined ? [] : [registry]), "en"]) {
    const value = record[key];
    if (typeof value === "string" && value.trim() !== "") return value;
  }
  return undefined;
}

export function packLabel(
  key: string,
  packs: readonly VerticalPack[] | undefined,
  language: string,
): string {
  const pack = packs?.find((p) => p.key === key);
  return pickLocalized(pack?.name, language) ?? key;
}
